import type { DepositType } from '@api';
import {
  SearchTableInput,
  TouringDataTable,
  useManageTableContext,
} from '@common';
import { Group } from '@mantine/core';
import { Route } from 'src/routes/_rootLayout/finance/deposits';
import { DepositsDueDateFilter } from './components';
import { useApplyDueDateFilter, useDepositsTableColumns } from './hooks';

type DepositsTablePropsType = {
  deposits: DepositType[];
  isPending: boolean;
};

export const DepositsTable: React.FC<DepositsTablePropsType> = ({
  deposits,
  isPending,
}) => {
  const { columns } = useDepositsTableColumns();
  const { dueDateFrom, dueDateTo } = Route.useSearch();
  const {
    tableArguments: {
      search: { searchValue, setSearchValue },
      pagination,
      sorting,
    },
  } = useManageTableContext();

  const { handleApplyDueDateFilter } = useApplyDueDateFilter();

  return (
    <>
      <Group
        align="flex-end"
        justify="space-between"
        gap="md"
        mb="xs"
        wrap="wrap"
      >
        <DepositsDueDateFilter
          dueDateFrom={dueDateFrom}
          dueDateTo={dueDateTo}
          onApplyDueDateFilter={handleApplyDueDateFilter}
        />
        <SearchTableInput
          search={searchValue ?? ''}
          setSearchValue={setSearchValue}
        />
      </Group>
      <TouringDataTable<DepositType>
        columns={columns}
        records={deposits}
        {...pagination}
        {...sorting}
        fetching={isPending}
      />
    </>
  );
};
